import axios from "axios";

export default {
    namespaced: true,
    state:{
        options: {
            projectStatusOptions: [
                //All, Open, Closed (default: Open)
                { value:"ALL", text:"All"},
                { value: null, text: "Open", disabled: false, update: false },
                { value: "CLOSED", text: "Closed", disabled: false, update: true },
            ],
        },
        filter: {
            projectId: "",
            name: "",
            description: "",
            status: "",
            duration: false,
            creationDate: "",
            page: 1,
            pageSize: 10,
        },
    },
    getters: {
        chats(state) {
        return state.chats;
        },
        total(state) {
        return state.total;
        },
        filter(state) {
        return state.filter;
        },
        getProjectList(state) {
        return state.projectList;
        },
        options(state) {
            return state.options;
          },
        getUpdated(state) {
            return state.filter.updated;
        }
    },
    actions: {
    },
    mutations: {
        setChats(state, chats) {
        state.chats = chats;
        },
        setTotal(state, total) {
        state.total = total;
        },
        incrementPage(state) {
        state.filter.page += 1;
        },
        setPage(state, page) {
        state.filter.page = page;
        },
        setAllProjectInfo(state, data) {
        state.allProjectInfo = data;
        },
        setAllProjectRoles(state, data) {
        state.allProjectRoles = data;
        },
        setUpdated(state, data) {
        state.filter.updated = data;
        },
        setSort(state, columns) {
        state.filter.sort = columns
            .filter(col => col.sort)
            .map(col => ({
                colName: col.colName,
                sort: col.sort
            }))
        },
        resetFilter(state) {
        
        }
    },
};